import Container from 'react-bootstrap/Container'
import MenuContentImages from './components/MenuContentImages/MenuContentImages'
import MenuContentLinks from './components/MenuContentLinks/MenuContentLinks'

import './MenuContent.scss'

const MenuContent = () => {
    return (
        <Container fluid className="menu-content d-flex">
            <MenuContentImages />
            <MenuContentLinks />
        </Container>
    )
}

export default MenuContent
